export function CMtoPixels(cm: number) {
  const dpi = 96 * window.devicePixelRatio;
  // dpi is dots (pixels) per inch
  const inch = 2.54;
  const inches = cm / inch;
  return dpi * inches;
}

export function pixelToCM(px: number) {
  const dpi = 96 * window.devicePixelRatio;
  return (px * 2.54) / dpi;
}

export function CMtoInches(value: number) {
  return (value / 100) * 39.37;
}

export function PXtoInches(value: number) {
  return pixelToCM(CMtoInches(value));
}
